
import {Vue, Component} from 'vue-property-decorator';
import {ProgramPaths} from "@/enum/ProgramPaths";
import {MAGAZA_URL} from "@/utils/lisansKisit";

@Component({})
export default class LoginCallback extends Vue {
  err:any=null;
  selectedTenant: string | null = this.$store.state.tenant_id;
  readonly dugmeRengi = '#1f2937';

  private get yanit(): any {
    return this.err && this.err.response ? this.err.response : null;
  }

  /** Lisans kaynakli giris engeli: hic lisans yok (403) ya da eski hattin suresi dolmus yaniti (401). */
  get lisansHatasi(): boolean {
    const r = this.yanit;
    if (!r || !r.data) return false;
    return (r.status == 401 && r.data.type == 'license_expired') || (r.status == 403 && r.data.type == 'license_none');
  }

  get kullaniciYok(): boolean {
    const r = this.yanit;
    return !!r && r.status == 401 && r.data && r.data.type == 'user_not_found';
  }

  /** Buro degistirme kutusu yalniz birden fazla buro varsa cikar; metin de ona gore. */
  get baskaBuroVar(): boolean {
    return this.tenantItems.length > 1;
  }

  /** Kartin tonu, simgesi, metni ve dugmesi. Yanitsiz hata da (ag, bos buro listesi) karsilanir. */
  get hata(): {ton: string; ikon: string; baslik: string; aciklama: string; kod: number | null; eylem: string | null} {
    const r = this.yanit;
    if (this.lisansHatasi && r.data.type == 'license_none') {
      return {
        ton: 'bilgi', ikon: 'mdi-cart-outline', baslik: 'Hesabınızda lisans bulunmuyor',
        aciklama: this.baskaBuroVar
            ? 'Bu büroya tanımlı bir ürün lisansı yok. Aşağıdan başka bir büronuza geçebilir ya da paket satın alarak kullanmaya başlayabilirsiniz.'
            : 'Bu büroya tanımlı bir ürün lisansı yok. Paket satın alarak hemen kullanmaya başlayabilirsiniz.',
        kod: null, eylem: 'Paketleri incele',
      };
    }
    if (this.lisansHatasi) {
      return {
        ton: 'hata', ikon: 'mdi-clock-alert-outline', baslik: 'Kullanım süreniz doldu',
        aciklama: this.baskaBuroVar
            ? 'Bu büronun lisans süresi dolduğu için giriş yapılamıyor. Süreyi uzatabilir ya da aşağıdan başka bir büronuza geçebilirsiniz.'
            : 'Bu büronun lisans süresi dolduğu için giriş yapılamıyor. Süreyi uzatarak kaldığınız yerden devam edebilirsiniz.',
        kod: null, eylem: 'Süreyi uzat',
      };
    }
    if (this.kullaniciYok) {
      return {
        ton: 'uyari', ikon: 'mdi-account-question-outline', baslik: 'Bu hesaba bağlı ürün bulunamadı',
        aciklama: 'Hata olduğunu düşünüyorsanız destek ekibimizle iletişime geçebilirsiniz.',
        kod: null, eylem: null,
      };
    }
    return {
      ton: 'hata', ikon: 'mdi-cloud-alert-outline', baslik: 'Giriş tamamlanamadı',
      aciklama: (r && r.data && r.data.message) || (this.err && this.err.message) || 'Beklenmeyen bir hata oluştu.',
      kod: r ? r.status : null, eylem: null,
    };
  }

  /** Suresi dolmus lisanslar (eski hattin 401 yaniti bitis tarihlerini tasir). */
  get lisansSatirlari(): Array<{ad: string; bitis: string}> {
    const veri = (this.yanit && this.yanit.data && this.yanit.data.license_data) || [];
    return veri.map((l: any) => ({ad: l.name, bitis: this.$helper.tarihSaatStr(l.end_date)}));
  }

  magazayiAc() {
    window.open(MAGAZA_URL, '_blank');
  }

  async mounted() {
    this.err=null
    await this.init();
  }

  async init() {
    try {
      let res = await this.$http.post('/api/v1/oauth/create-token', this.$route.query);
      this.$store.commit('setAccessToken', res.data.access_token);
      let tenantList = await this.$store.dispatch("getTenantList");
      if (tenantList.length > 0) {
        let defaultTenant = tenantList[0];
        this.$store.commit('setTenantId', defaultTenant.tenant_id);
      } else {
        throw new Error("Ürün lisansınız bulunamadı!");
      }
      //sessionStorage.setItem('tenantId', res.data.tenant_id);
      let routingPath = localStorage.getItem('routingPath');
      let userRes = await this.$http.get("/api/v1/ben")
      this.$store.commit('setUser', userRes);
      //nerden gelmis Eimza ile girdiyse direk eicrapro.
      let icwLicence = userRes.licenses.find(licence=>{ licence.name == "İcraProWeb" });
      let eicLicence = userRes.licenses.find(licence=>{ licence.name == "E-İcraPro" });
      if(icwLicence && !routingPath){
        routingPath = ProgramPaths.icrapro;
      }else{
        if(eicLicence)
          routingPath = ProgramPaths.eicrapro;
      }
      //licenses
      //E-İcraPro
      //İcraProWeb
      //name
      //this.$store.dispatch('updateTasks');
      //this.$router.push(ProgramPaths.ofispro);
      if (routingPath) {
        if (routingPath == "/giris")
          this.$router.push(ProgramPaths.ofispro);
        else
          this.$router.push(routingPath);
        //location.href = routingPath;
        localStorage.removeItem('routingPath');
      } else {
        this.$router.push(ProgramPaths.ofispro);
        //location.href = ProgramPaths.ofispro;
      }
    } catch (e) {
      console.error('HATA------: ',e);
      this.err=e;
    }
  }



  get tenantItems() {
    return this.$store.state.tenantList;
  }
  onTenantChange(newTenantId: string) {
    const tenant = this.tenantItems.find((item:any) => item.tenant_id === newTenantId);
    if (tenant) {
      this.switchTenant(tenant);
    }
  }

  isDisabled(tenantId: string) {
    return this.$store.state.tenant_id === tenantId;
  }

  async switchTenant(item: any) {
    const oncekiBuro = this.$store.state.tenant_id;
    try {
      this.$toast.info("Oturum değişikliği yapılıyor");

      // Set the selected tenant ID in the store
      this.$store.commit("setTenantId", item.tenant_id);

      // DEV-2113 — $http yanitin govdesini dondurur (init ve ust menudeki gecis
      // de boyle kullanir). Burada `userRes.data` (undefined) yaziliyordu: oturuma
      // "undefined" kaydediliyor, yenilemede uygulama JSON.parse ile acilamiyordu
      // (beyaz ekran, sekme kurtarilamiyor).
      const user = await this.$http.get("/api/v1/ben");
      this.$store.commit('setUser', user);

      // Basarili girisle ayni yol: sayfa YENILENMEZ. Giris donus adresi
      // (?code=...) yenilenseydi kullanilmis kod ikinci kez takas edilmeye
      // calisilirdi. Hangi urun ekraninin acilacagina koruma karar verir.
      this.$router.push(ProgramPaths.ofispro);
    } catch (error) {
      console.error('Error while switching tenant:', error);
      // Kart hala onceki buroyu anlatiyor: secim ona doner, kutu kullanilabilir kalir.
      this.$store.commit("setTenantId", oncekiBuro);
      this.selectedTenant = null;
      const tip = (error as any)?.response?.data?.type;
      this.$toast.error(tip === 'license_none' || tip === 'license_expired'
          ? "Seçtiğiniz büroya da tanımlı geçerli bir lisans bulunmuyor"
          : "Oturum değişikliği sırasında bir hata oluştu");
    }
  }

}
